import React, { Fragment, useState, useEffect, useRef } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import AssetEarningConfig from '../../models/AssetEarningsConfig';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { assetEarningConfig, setAssetEarningConfig, reset } = props;
  let assetEarningConfigObj = new AssetEarningConfig(assetEarningConfig);

  const [offersApi] = getApi('offers');
  const [rfidTypesApi] = getApi('rfidTypes');
  const [assetEarningConfigsApi] = getApi('assetEarningConfigs');
  const [offers, setOffers] = useState([]);
  const [rfidTypes, setRfidTypes] = useState([]);
  const multiselectOffersRef = useRef();
  const multiselectRfidTypesRef = useRef();

  useEffect(() => {
    fetchApiData(offersApi, "offers", { fields: 'options', rental_offers: true, filters: { offer_type_id: 2 } }, setOffers);
  }, [])

  useEffect(() => {
    multiselectOffersRef.current.resetSelectedValues();
    multiselectRfidTypesRef.current.resetSelectedValues();
  }, [reset])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      toast.error("Something Went Wrong !");
    }
  }

  const onSelectOffer = (key, selectedItem) => {
    assetEarningConfigObj[key] = selectedItem.id;
    assetEarningConfigObj.rfid_type_id = "";
    assetEarningConfigObj.asset_earning_configs_items = [];
    assetEarningConfigObj.deleted_configs = [];
    
    validateValue(key);
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());

    multiselectOffersRef.current.onCloseOptionList();
    setRfidTypes([]);
    fetchApiData(rfidTypesApi, "rfid_types", { fields: 'options', filters: { offer_id: selectedItem.id } }, setRfidTypes);
  }

  const onRemoveOffer = (key, removedItem) => {
    assetEarningConfigObj[key] = "";
    assetEarningConfigObj.rfid_type_id = "";
    assetEarningConfigObj.asset_earning_configs_items = [];
    assetEarningConfigObj.deleted_configs = [];

    validateValue(key);
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());
    setRfidTypes([]);
    multiselectRfidTypesRef.current.resetSelectedValues();
    multiselectOffersRef.current.onFocus();
  }

  const onSelectRfidType = async (key, selectedItem) => {
    assetEarningConfigObj.rfid_type_id = selectedItem.id;
    multiselectRfidTypesRef.current.onCloseOptionList();

    assetEarningConfigObj[key] = selectedItem.id;
    assetEarningConfigObj.deleted_configs = [];

    validateValue(key);
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());

    let response = await assetEarningConfigsApi({
        filters: {
            offer_id: assetEarningConfigObj.offer_id,
            rfid_type_id: selectedItem.id
        }
    }
    ).unwrap();
    if(response.data.asset_earning_configs.length === 1) {
      assetEarningConfigObj.asset_earning_configs_items = response.data.asset_earning_configs[0].asset_earning_config_items
      setAssetEarningConfig(new AssetEarningConfig(assetEarningConfigObj, true))
    }
  }

  const onRemoveRfidType = (key, removedItem) => {
    assetEarningConfigObj[key] = "";
    assetEarningConfigObj.asset_earning_configs_items = [];
    assetEarningConfigObj.deleted_configs = [];

    validateValue(key);
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());
    multiselectRfidTypesRef.current.onFocus();
  }

  const validateValue = (field) => {
    assetEarningConfigObj.validate(field);
  }

  // const changeValue = (field, value) => {
  //   assetEarningConfigObj[field] = value;
  //   validateValue(field);
  //   props.setAssetEarningConfig(assetEarningConfigObj.toStateJson());
  // }

  const handleChangeDynamicFields = (id, event) => {
      setAssetEarningConfig((prev_state) => {
        return {
          ...prev_state,
          asset_earning_configs_items : prev_state.asset_earning_configs_items.map(i => {
            if (id === i.key) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        }
      });
  }

  const handleAddFields = (e) => {
    e.preventDefault();
    assetEarningConfigObj.asset_earning_configs_items.push(
      { 
        key: assetEarningConfigObj.asset_earning_configs_items.length, 
        previous_item_key: "", 
        start_num: '', end_num: '', 
        amount: '', 
        earning_type: '', 
        status: 'active'
      }
    )
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());
  };

  const handleDeleteFields = (event, index) => {
    event.preventDefault();
    assetEarningConfigObj.asset_earning_configs_items = assetEarningConfigObj.asset_earning_configs_items.filter((earning_config) => {
      if (earning_config.id && earning_config.key === index) {
        assetEarningConfigObj.deleted_configs.push({ ...earning_config, _destroy: true });
      }
      return earning_config.key !== index;
    })
    setAssetEarningConfig(assetEarningConfigObj.toStateJson());
  };

  return <Fragment>
    <div className="col-md-6">
      <label htmlFor='offer_id' className="form-label mb-0">Select Offer</label>
      <Multiselect
        id='offer_id'
        options={offers}
        onSelect={(selectedList, selectedItem) => onSelectOffer("offer_id", selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveOffer("offer_id", removedItem)}
        placeholder='Select Offer'
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        singleSelect={true}
        avoidHighlightFirstOption={true}
        ref={multiselectOffersRef}
      />
      <div id="offer_id_help" className="form-text text-danger mt-0">
        {assetEarningConfigObj.errors.offer_id}
      </div>
    </div>

    <div className="col-md-6">
      <label htmlFor='rfid_type_id' className="form-label mb-0">Select RFID Type</label>
      <Multiselect
        id='rfid_type_id'
        options={rfidTypes}
        onSelect={(selectedList, selectedItem) => onSelectRfidType("rfid_type_id", selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveRfidType("rfid_type_id", removedItem)}
        placeholder='Select Rfid Type'
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        singleSelect={true}
        avoidHighlightFirstOption={true}
        ref={multiselectRfidTypesRef}
      />
      <div id="rfid_type_id_help" className="form-text text-danger mt-0">
        {assetEarningConfigObj.errors.rfid_type_id}
      </div>
    </div>

    <div >
      {assetEarningConfigObj.asset_earning_configs_items.map((field, index) => (
        <div className="m-2" key={field.key}>
          <div className="row bg-light border p-3 rounded">
            <p className="col-1">Current Id - {field.key}</p>
            <div className="col">
              <label htmlFor="start_num" className="form-label mb-0">From</label>
              <input
                id='start_num'
                name='start_num'
                type='number'
                placeholder='Enter Start Number'
                value={field.start_num}
                className="form-control form-control-sm font-size-10 my-1"
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
              />
            </div>
            <div className="col">
              <label htmlFor="end_num" className="form-label mb-0">To</label>
              <input
                id='end_num'
                name='end_num'
                type='number'
                placeholder='Enter End Number'
                value={field.end_num}
                className="form-control form-control-sm font-size-10 my-1"
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
              />
            </div>
            <div className="col">
              <label htmlFor="amount" className="form-label mb-0">Amount</label>
              <input
                id='amount'
                name='amount'
                type='number'
                placeholder='Enter Amount'
                value={field.amount}
                className="form-control form-control-sm font-size-10 my-1"
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
              />
            </div>
            <div className="col">
              <label htmlFor="earning_type" className="form-label mb-0">Select Earning Type</label>
              <select
                id="earning_type"
                name='earning_type'
                className="form-control form-control-sm font-size-10 my-1"
                value={field.earning_type}
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
              >
                <option value="" disabled>Select Earning Type</option>
                <option value="vehicle">Vehicle</option>
                <option value="swap">Swap</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="previous_item_key" className="form-label mb-0">Previous Configuration Id</label>
              <input
                id='previous_item_key'
                name='previous_item_key'
                type='number'
                placeholder='Enter Index'
                value={field.previous_item_key}
                className="form-control form-control-sm font-size-10 my-1"
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
                onBlur={(e) => validateValue('previous_item_key')}
                />
              { assetEarningConfigObj.errors.asset_earning_items && 
                assetEarningConfigObj.errors.asset_earning_items.length > index &&  
                  <div id="config_previous_item_key_help" className="form-text text-danger mt-0">
                    {assetEarningConfigObj.errors.asset_earning_items[index].previous_item_key}
                  </div>
              }
            </div>
            <div className="col">
              <label htmlFor="status" className="form-label mb-0">Select Status</label>
              <select
                id="status"
                name='status'
                className="form-control form-control-sm font-size-10 my-1"
                value={field.status}
                onChange={(event) => handleChangeDynamicFields(field.key, event)}
              >
                <option value="" disabled>Select Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
          {
            index === assetEarningConfigObj.asset_earning_configs_items.length - 1 &&
            <button
              onClick={handleAddFields}
              className="add-button my-2 me-2 px-3"
              disabled={assetEarningConfigObj.offer_id === "" || assetEarningConfigObj.rfid_type_id === ""}
            >
              Add New Configuration
          </button>
          }
          {
            index !== 0 && index === assetEarningConfigObj.asset_earning_configs_items.length - 1 &&
              <button onClick={(e) => handleDeleteFields(e, index)} className="remove-button my-2 px-3">
                Remove Configuration
              </button>
          }
        </div>
      ))}
    </div>
    { assetEarningConfigObj.asset_earning_configs_items.length === 0 &&
      <button
        onClick={handleAddFields}
        className="add-button my-2 mx-3"
        disabled={assetEarningConfigObj.offer_id === "" || assetEarningConfigObj.rfid_type_id === ""}
      >
        Add New Configuration
      </button>
    }
  </Fragment >
}

export default FormPartial;
